import React from 'react';
import { is, propOr, pathOr } from 'ramda';

import { notEmpty, mapIndexed } from 'utils/ramdaAdditions';
import { TextLine, Line } from './lineTemplates';
import {
    DocumentLink,
    EventLink,
    PersonLink,
    ProjectLink,
    CompanyLink
} from './linkTemplates';

const itemTypes = {
    'Document': DocumentLink,
    'Event':    EventLink,
    'Person':   PersonLink,
    'People':   PersonLink,
    'Project':  ProjectLink,
    "Company":  CompanyLink
};

const getText = item => pathOr(propOr(item, 'text', item), ['text', 'title'], item);

const renderItem = (item, index, rowIndex, handlers ) => {
    const Template = itemTypes[item.type];

    if (Template) {
        return <Template handlers={handlers} rowIndex={rowIndex} key={index} value={item} />;
    }

    const value = getText(item);

    return (
        <TextLine key={index} value={value} />
    );
};

const List = ({ children: renderLine, value: list, rowIndex, handlers }) => (
    <div>
        { is(Array, list) && notEmpty(list) && mapIndexed((value, index) => (
            <Line key={index} index={index} LineComponent="div">
                {renderLine(value, index, rowIndex, handlers)}
            </Line>
        ), list)}
    </div>
);

export const ItemsList = (props) => (
    <List {...props}>
        {renderItem}
    </List>
);
